/**
 * MyOrganizationRedirect component
 * Redirects org_owner and org_admin users to their organization detail page
 */

import { Navigate, useSearchParams } from 'react-router-dom';
import { Spinner, makeStyles } from '@fluentui/react-components';
import { useAuth } from '../contexts/AuthContext';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
  },
});

export function MyOrganizationRedirect() {
  const styles = useStyles();
  const { user, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  if (isLoading) {
    return (
      <div className={styles.container}>
        <Spinner label="Loading..." />
      </div>
    );
  }

  // Preserve query parameters (e.g., ?tab=users) in the redirect
  const queryString = searchParams.toString();
  const suffix = queryString ? `?${queryString}` : '';

  // If user has an organization, redirect to their org detail page
  if (user?.organization_id) {
    return <Navigate to={`/app/admin/organizations/${user.organization_id}${suffix}`} replace />;
  }

  // Fallback to organizations list for global admins without specific org
  return <Navigate to="/app/admin/organizations" replace />;
}
